import React, { lazy, Suspense } from "react";
import './App.css';
//import ThankYou from "./components/ThankYou";
import Navbar from './components/Navbar';
import desktopbg from './Images/desktop-bg.webp'
import SocialMedia from './components/SocialMedia'
import ThankYou from './components/ThankYou'
import Gallery from "./components/Gallery"


const Header = lazy(() => import("./components/Header"));
const EventMemories = lazy(() => import("./components/EventMemories"));
const Body = lazy(() => import("./components/Body"));
const SubscribeForEventNotifications = lazy(() => import("./components/SubscribeForEventNotifications"));
const ContactUs = lazy(() => import("./components/ContactUs"));
const Footer = lazy(() => import("./components/Footer"));



function App() {
  const imgCDNURL = process.env.REACT_APP_SUNWESTEXPO_CDN_URL;

  return (
    <>
      <div className="appBodyContainer">
        
        <img src= {desktopbg} className="desktop-bg img-fluid" alt="desktop-bg"/> 
        <img src={imgCDNURL + "mobilebg.webp"} className="mobile-bg img-fluid" alt="mobile-bg" />
        <img src={imgCDNURL + "flower.webp"} className="flower1 img-fluid" alt="flower" />
        <img src={imgCDNURL + "flower.webp"} className="flower2 img-fluid" alt="flower" />
        <img src={imgCDNURL + "flower.webp"} className="flower3 img-fluid" alt="flower" />
        <img src={imgCDNURL + "dots-12.webp"} className="dots img-fluid" alt="flower" />
        <Navbar />  
        <Suspense fallback={<div />}>
          <Header />
        </Suspense>
      </div>
      
      <Suspense fallback={<div />}>
      <Gallery /> 
     {/* <EventMemories />  */}
      </Suspense>
      {/* <Suspense fallback={<div />}>
        <Body />
      </Suspense> */}
      <SocialMedia />
      <ThankYou />
      {/* <ThankYou /> */}
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications />
      </Suspense> 
      <Suspense fallback={<div />}>
        <ContactUs />
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
    </>
  );
}

export default App;
